<div class="hunt-query-card">
    <div class="header" [class.no-margin]="!isOpen">
      <div class="logo">
        <hyperkit-logo [icon]="getIconForProduct(tool.product)" [size]="'medium'"></hyperkit-logo>
        <hyperkit-typography variant="label1" color="primary">{{tool.name}}</hyperkit-typography>
      </div>
      <div class="page-counter" (click)="toggle()" style="cursor: pointer;">
          <!-- {{ completedEndpoints }}/{{ totalEndpoints }}
          <div class="cheveron">
            <hyperkit-icon icon="chevron-up" size="medium" *ngIf="isOpen"></hyperkit-icon>
            <hyperkit-icon icon="chevron-down" size="medium" *ngIf="!isOpen"></hyperkit-icon>
          </div> -->
          <div class="cheveron">
            <hyperkit-icon icon="chevron-up" size="medium" *ngIf="isOpen"></hyperkit-icon>
            <hyperkit-icon icon="chevron-down" size="medium" *ngIf="!isOpen"></hyperkit-icon>
          </div>
      </div>
  </div>
    
  <div class="endpoints" *ngIf="isOpen">
    <ng-container *ngFor="let query of tool.generatedContent.Hunt; let i = index">
      <!-- Primary Hunt Query -->
      <div
        class="endpoint-item"
        [class.active]="selectedQueryId === tool.id + '::' + i"
        (click)="queryClick.emit({ type: 'query', tool: tool, index: i })"
      >
        <hyperkit-icon icon="code" size="base"></hyperkit-icon>
        <hyperkit-typography variant="label1" class="endpoint-name" color="primary">
          {{ query.category }}
        </hyperkit-typography>
        <div class="status-icon">
          <hyperkit-icon icon="check-circle" size="medium" *ngIf="isHuntComplete"></hyperkit-icon>
          <!-- <hyperkit-icon icon="loader" size="medium" class="spinner" *ngIf="!isHuntComplete"></hyperkit-icon> -->
        </div>
      </div>

      <!-- Pivot Queries (if any) -->
      <div
        *ngFor="let pivot of query.pivots; let j = index"
        class="endpoint-item pivot"
        [class.active]="selectedQueryId === tool.id + '::' + i + '::' + j"

        (click)="queryClick.emit({ type: 'pivot', tool: tool, queryIndex: i, pivotIndex: j })"
      >
        <hyperkit-icon icon="shuffle" size="base"></hyperkit-icon>
        <hyperkit-typography variant="label1" class="endpoint-name" color="primary">
          {{ pivot.title }}
        </hyperkit-typography>
        <div class="status-icon">
          <!-- <hyperkit-icon icon="loader" size="medium" class="spinner"></hyperkit-icon> -->
        </div>
      </div>
    </ng-container>
  </div>
</div>